import { BOUNCY_SUMS_NUMPAD_DIGITS } from '@/features/bouncySums/constants';

import '@/features/bouncySums/styles/bouncy-sums-numpad.scss';

import type { MouseEvent } from 'react';

type BouncySumsNumpadProps = {
	isVisible: boolean;
	onDigit: (digit: string) => void;
};

const BouncySumsNumpad = ({ isVisible, onDigit }: BouncySumsNumpadProps) => {
	const handleClick = (event: MouseEvent<HTMLButtonElement>, digit: string) => {
		if (event.detail === 0) {
			onDigit(digit);
		}
	};

	if (!isVisible) {
		return null;
	}

	return (
		<div className="bouncy-sums-game__numpad">
			{BOUNCY_SUMS_NUMPAD_DIGITS.map((digit) => (
				<button
					key={digit}
					className="bouncy-sums-game__numpad-key"
					type="button"
					data-key={digit}
					onClick={(event) => handleClick(event, digit)}
					onPointerDown={() => onDigit(digit)}
				>
					{digit}
				</button>
			))}
		</div>
	);
};

export default BouncySumsNumpad;
